import React, { useState } from 'react';
import ssalsoongiIcon from '../assets/ssalsoongi_icon.png';
import SsalsoongiModal from './SsalsoongiModal';

export default function SsalsoongIButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          position: 'absolute',
          top: 186,
          right: 0,
          zIndex: 1200,
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
        }}
      >
        <img src={ssalsoongiIcon} alt="Leaderboard" style={{ width: 70, height: 70 }} />
      </button>
      <SsalsoongiModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
